<template>
	<div class="page-index" v-loading="body_loading">
		<div class="main-body">
			<div class="hd"><h3>概况中心 <span>欢迎回来，<i>{{account_name}}</i></span></h3></div>
			<div class="bd">
				<el-row :gutter="25">
					<el-col :span="24">
						<div ref="contentBody" class="content-body" style="padding: 0;margin-bottom: 0;">
							<div class="bd">
								<el-row :gutter="20">
									<el-col :xs="24" :sm="24" :lg="24">
										<div class="log-box content-body" style="position: relative;">
											<div class="hd" style="margin-bottom: 0">
												<h4>操作日志</h4>
											</div>
											<div class="bd">
												<el-table ref="multipleTable" :data="table_log.list" height="650px" v-loading="table_log.loading" tooltip-effect="dark" style="width: 100%;text-align: center;">
													<el-table-column prop="createdate" align="center" label="时间" min-width="140">
													</el-table-column>
													<el-table-column prop="userName" align="center" label="用户名" min-width="120">
													</el-table-column>
													<el-table-column prop="logType" align="center" label="日志类型" min-width="90">
													</el-table-column>
													<el-table-column prop="funcName" align="center" label="funcName" min-width="120">
													</el-table-column>
													<el-table-column prop="funcRemark" align="center" label="funcRemark" min-width="90">
													</el-table-column>
													<!-- <el-table-column prop="status_name" align="center" label="状态" min-width="80">
														<template slot-scope="scope">
															<span :class="'status-'+scope.row.status">{{scope.row.status_name}}</span>
														</template>
													</el-table-column> -->
												</el-table>
												<el-pagination
												         @size-change="handleSizeChange"
												         @current-change="handleCurrentChange"
												         :current-page="table_log.page_info.page"
												         :page-sizes="[10,30, 50,80,100]"
												         :page-size="table_log.page_info.pageSize"
												         layout="total, sizes, prev, pager, next"
												         :total="table_log.page_info.total">
												 </el-pagination>
											</div>
										</div>
									</el-col>
								</el-row>
								
							</div>
						</div>
					</el-col>
				</el-row>
			</div>
		</div>
	</div>
</template>
<script>
	import bus from '@/assets/js/defined.js'
	import MyEcharts from '@/components/MyEcharts/index.vue'
	export default {
		name: 'index',
		components: {
			MyEcharts
		},
		data() {
			return {
				create_range:'',
				clientHeight:'',
				body_loading:false,
				account_name:"",
				is_refresh:true,
				message_count:0,
				count_data:[],
				count_dataMonthDay:[],
				init_data:{
					show_top_bar: false,
					show_statistics_table: false,
					show_product_table: false,
					time_list:[{id:7,name:'近7天'},{id:15,name:'近15天'},{id:30,name:'近30天'}],
					time_table_list:[{id:-1,name:'总榜'},{id:7,name:'近7天'},{id:15,name:'近15天'},{id:30,name:'近30天'}]
				},
				deal_num:{
					num1:0,
					num2:0,
					num3:0,
					num4:0,
					num5:0
				},
				order_count: {
					loading:false,
					form:{
						time:7
					},
					data:{
						name: '营业额',
						data: [10,20,40],
						color:"#24D069",
						xAxis:['2020-05-30','2020-05-31','2020-06-01'],
						title:"年度营业额统计",
						subtitle:"单位：月/元",
						unit:'元'
					}
				},
				count_dataMonthDay_count: {
					loading:false,
					form:{
						time:7
					},
					data:{
						name: '本月日销售金额',
						data: [10,20,40],
						color:"#3992FF",
						xAxis:['2020-05-30','2020-05-31','2020-06-01'],
						title:"本月日销售金额统计",
						subtitle:"单位：元/天",
						unit:'元'
					}
				},
				paid_amount: {
					loading:false,
					form:{
						time:7
					},
					data:{
						name: '订单实收总额',
						data: [10,20,40],
						color:"#a366ff",
						xAxis:['2020-05-30','2020-05-31','2020-06-01'],
						title:"订单实收总额统计",
						subtitle:"单位：元/天",
						unit:'元'
					}
				},
				table_hot:{
					loading:false,
					list:[],
					form:{
						searchStartDate:'',
						searchEndDate:''
					},
					page_info:{
						page: 1,
						pageSize: 6,
						total: 6
					}
				},
				table_collect:{
					loading:false,
					list:[],
					form:{
						time:-1
					},
					page_info:{
						page: 1,
						pageSize: 6,
						total: 6
					}
				},
				table_log:{
					loading:false,
					list:[],
					page_info:{
						page: 1,
						pageSize: 30,
						total: 6
					}
				},
				todySellData:{}
			}
		},
		created() {
			document.title = '个人中心';
			this.account_name = localStorage.getItem('username');
			this.getInitData();
			this.getInitDataDay();
			// this.getEchartData(this.order_count.form.time,1);
			// this.getEchartData(this.sale_total_amount.form.time,2);
			// this.getEchartData(this.paid_amount.form.time,3);
			this.getHotData();
			this.getMainPageDataForAdmin()
			// this.getCollectData();
			this.getLogData();
			this.message_count = localStorage.getItem('message_count');
		},
		methods: {
			getMainPageDataForAdmin(){
				var _this = this;
				this.$client.get('/api/biz/order/getMainPageDataForAdmin', {}, function(res,message){
					_this.todySellData = res;
						
				},function(res){
			
				});
			},
			
			getInitData(){
				var _this = this;
				this.$client.get('/api/biz/order/getMonthTurnoverReportByYear', {}, function(res,message){
					_this.count_data = res;
						var xAxisTime=[]
						var dataTotal=[]
					_this.count_data.forEach((item,index)=>{
						xAxisTime.push(item.year+'-'+item.month)
						dataTotal.push(item.totalAmount)
					})
					_this.order_count.data.xAxis=xAxisTime
					_this.order_count.data.data=dataTotal
				},function(res){

				});
			},
			
			getInitDataDay(){
				var _this = this;
				var parmas={
					
				}
				this.$client.get('/api/biz/order/getDayTurnoverReportByMonth', {parmas}, function(res,message){
					_this.count_dataMonthDay = res;
					var xAxisTime=[]
					var dataTotal=[]
					_this.count_dataMonthDay.forEach((item,index)=>{
						xAxisTime.push(item.day+'日')
						dataTotal.push(item.totalAmount)
					})
					_this.count_dataMonthDay_count.data.xAxis=xAxisTime
					_this.count_dataMonthDay_count.data.data=dataTotal
					
				},function(res){
			
				});
			},
			getHotData(){
				var _this = this;
				_this.table_hot.loading = true;
				var params = {searchStartDate:this.table_hot.form.searchStartDate,searchEndDate:this.table_hot.form.searchEndDate};
				params.limit =30;
				// params.pageSize = _this.table_hot.page_info.pageSize;
				this.$client.get('/api/biz/order/getCookSellsReport', params, function(res,message){
					console.log(res,"热销排行版")
					_this.table_hot.list = res;
					_this.table_hot.loading = false;
					// _this.table_hot.page_info = res.pager;
				},function(res){
					_this.table_hot.loading = false;
				});
			},
			getCollectData(){
				var _this = this;
				_this.table_collect.loading = true;
				var params = {c_time_lately_day:this.table_collect.form.time};
				params.p = _this.table_collect.page_info.page;
				params.pageSize = _this.table_collect.page_info.pageSize;
				this.$client.get('/adminapi/statis/skuCollectData',params , function(res,message){
					_this.table_collect.list = res.list;
					_this.table_collect.loading = false;
					_this.table_collect.page_info = res.pager;
				},function(res){
					_this.table_collect.loading = false;
				});
			},
			getLogData(){
				var _this = this;
				_this.table_log.loading = true;
				var params = {};
				params.pageNo = _this.table_log.page_info.page;
				params.pageSize = _this.table_log.page_info.pageSize;
				this.$client.get('/api/sys/log/getList',params , function(res,message,total,totalPages){
					_this.table_log.list = res;
					_this.table_log.loading = false;
					// _this.table_log.page_info = res.pager;
					_this.table_log.page_info.total=total
				},function(res){
					_this.table_log.loading = false;
				});
			},
			handleSizeChange(val) {
			    //console.log(`每页 ${val} 条`);
			    this.table_log.page_info.pageSize = val;
			    this.getLogData();
			},
			handleCurrentChange(val) {
			    //console.log(`当前页: ${val}`);
			    this.table_log.page_info.page = val;
			    this.getLogData();
			},
			getEchartData(lately_day,type){
				var _this = this;
				var params = {
					lately_day:lately_day,
					query_type:type
				};
				var query_key_data = '';
				if(type==1){
					query_key_data = 'order_count';
				}else if(type==2) {
					query_key_data = 'count_dataMonthDay_count';
				}else if(type==3) {
					query_key_data = 'paid_amount';
				}
				_this[query_key_data].loading = true;
				this.$client.get('/adminapi/statis/orderData', params, function(res,message){
					//console.log(query_key_data);
					//console.log(res[query_key_data]);
					_this[query_key_data].data.data = res[query_key_data];
					_this[query_key_data].data.xAxis = res.a_time;
					_this[query_key_data].loading = false;
				},function(res){
					_this[query_key_data].loading = false;
				});
			},
			changeDate(type){
				var query_key_data = '';
				if(type==1){
					query_key_data = 'order_count';
				}else if(type==2) {
					
					query_key_data = 'count_dataMonthDay_count';
				}else if(type==3) {
					query_key_data = 'paid_amount';
				}
				this.getEchartData(this[query_key_data].form.time,type)
			},
			goToIndex(){
				location.href='/index';
			},
			getTableHot(){

			},
			/*goToProduct(href_link){
				location.href=href_link;
			},*/
			changeFixed(clientHeight){                        //动态修改样式
				this.$refs.contentBody.style.minHeight = (clientHeight-413)+'px';
				//this.$refs.contentBody2.style.minHeight = (clientHeight-413)+'px';

			}
		},
		mounted(){
			// 获取浏览器可视区域高度
			this.clientHeight =   `${document.documentElement.clientHeight}`          //document.body.clientWidth;
			//console.log(self.clientHeight);
			window.onresize = function temp() {
				this.clientHeight = `${document.documentElement.clientHeight}`;
			};
			bus.$on("msgCountChange", (new_count) => {
				this.message_count = new_count;
				localStorage.setItem('message_count',new_count);
			});
		},
		watch: {
			// 如果 `clientHeight` 发生改变，这个函数就会运行
			clientHeight: function () {
				this.changeFixed(this.clientHeight)
			},
			create_range(newVal) {
				//console.log(newVal);
				if (newVal == null) {
					this.table_hot.form.searchStartDate = '';
					this.table_hot.form.searchEndDate = '';
				} else {
					this.table_hot.form.searchStartDate = newVal[0];
					this.table_hot.form.searchEndDate = newVal[1];
				}
			}
		}
	}
</script>
<style>
	.page-index .el-table td, .page-index .el-table th{
		padding: 6px 0;
	}
	.page-index .el-table td{
		border-bottom: none !important;
	}
	.log-box .el-table .cell{
		font-size: 12px;
	}
</style>
<style scoped>
	.el-main .content-body .hd {
		margin-bottom: 0;
	}
	.el-main .content-body .hd h4{
		font-size:16px;
		font-family:PingFang SC;
		font-weight:bold;
		color:rgba(22,22,22,1);
	}
	.page-index .bd .echarts-box{
		height: 380px;
		background:rgba(255,255,255,1);
		border-radius:10px;
	}
	.page-index .bd .table-box,.page-index .bd .deal-box,.page-index .bd .log-box{
		background:rgba(255,255,255,1);
		border-radius:10px;
		height: 280px;
	}
	.form-box{position: absolute;right: 4px;top: 10px;}
	.sort{
		width:24px;
		height:24px;
		display: inline-block;
		background:#fff;
		border-radius:5px;
		font-size:16px;
		font-family:PingFang SC;
		color:#161616;
		text-align: center;
		line-height: 24px;
	}
	.sort-0{
		font-weight:600;
		color: #fff;
		background:rgba(255,207,13,1);
	}
	.sort-1{
		font-weight:600;
		color: #fff;
		background:rgba(220,220,220,1);
	}
	.sort-2{
		font-weight:600;
		color: #fff;
		background:rgba(201,155,102,1);
	}
	.deal-content{
		padding: 10px 0;
		flex-wrap: wrap;
		justify-content: flex-start;
	}
	.deal-content .deal-item{
		width: 50%;
		padding: 15px 0;
		justify-content: space-around;
		cursor: pointer;
	}
	.deal-content .deal-item .name-box{
		font-size:14px;
		font-family:PingFang SC;
		font-weight:bold;
		color:rgba(22,22,22,1);
		line-height: 30px;
	}
	.deal-content .deal-item .num-box{
		width:60px;
		height:30px;
		background:rgba(238,238,238,1);
		border-radius:15px;
		display: inline-block;
		text-align: center;
		line-height: 30px;
		font-size:16px;
		font-family:PingFang SC;
		font-weight:bold;
		color:rgba(22,22,22,1);
	}
	.deal-content .deal-item .num-red{
		color: #FF0000;
	}
	.adv-img-box{
		height: 80px;
		background: url("../../assets/img/guanggao_pic.png") 0 center no-repeat;
		background-size:cover;
		font-size:20px;
		font-family:PingFang SC;
		border-radius: 10px;
		padding-right: 20px;
		color:rgba(167,158,140,1);
		text-align: right;
		line-height: 80px;
		margin-bottom: 20px;
	}
</style>